module.exports = __webpack_public_path__ + "img/q-img-4.b0e76487.jpg";